/*
 * ARTMiE Recommendations widget.
 * Reads window.AMH_RECO (injected by amh-reco.liquid from the shop metafield),
 * fetches a market-scoped "recommended for you" row from the Marketing Hub, and
 * renders it. Rendering recommendations is NOT tracking; only the impression/click
 * FEEDBACK events are gated on cookie consent (no post-rejection tracking).
 *
 * Config shape:
 *   { apiBase, placement, market?|marketByHost?, hosts?, title?|titleByHost?,
 *     mount?, count?, color?, consentRequired? }
 */
(function () {
  "use strict";
  var C = window.AMH_RECO;
  if (!C || C.active === false || !C.placement) return; // guarded: inactive config renders nothing
  var API = C.apiBase || ""; // empty = same origin (used by the local preview)

  var host = location.hostname.replace(/^www\./, "");

  // Host gate: if a hosts allow-list is set, only run on those storefronts.
  if (Array.isArray(C.hosts) && C.hosts.length && C.hosts.indexOf(host) === -1) return;

  // Page gate: if `pages` is set, only render where the path matches (e.g. ["/products/"]).
  if (Array.isArray(C.pages) && C.pages.length) {
    var path = location.pathname;
    var pageOk = C.pages.some(function (p) { return path.indexOf(p) !== -1; });
    if (!pageOk) return;
  }

  // Resolve the visitor's market (explicit, or by host, else abort — never guess).
  var market = C.market || (C.marketByHost && C.marketByHost[host]);
  if (!market) return;

  var title = C.title || (C.titleByHost && C.titleByHost[host]) || "Recommended for you";
  var accent = C.color || "#7A2E6C";
  var count = C.count || 8;

  // Anonymous, per-browser session id (no PII).
  var sid = (function () {
    try {
      var k = "amh_sid", v = localStorage.getItem(k);
      if (!v) { v = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(k, v); }
      return v;
    } catch (e) { return null; }
  })();

  // Consent gate for FEEDBACK only (rendering itself is never tracking, so it stays ungated).
  // Shopify's Customer Privacy API is authoritative, but it is NOT present until loaded via
  // Shopify.loadFeatures — so we load it, gate on analyticsProcessingAllowed(), and subscribe to
  // consent changes. Events raised before the decision is known are QUEUED, then flushed (or
  // dropped) once consent resolves. Privacy-first: unknown/declined → nothing is sent.
  var _consent = null; // null = undecided, true/false once known
  var _queue = [];

  function _send(type, item) {
    try {
      var body = JSON.stringify({ type: type, market: market, placement: C.placement, item: item, session: sid });
      // text/plain keeps sendBeacon a CORS-simple request (application/json needs a preflight
      // that sendBeacon can't do → silently dropped); the server parses the body regardless.
      if (navigator.sendBeacon) navigator.sendBeacon(API + "/api/public/reco/feedback", new Blob([body], { type: "text/plain" }));
      else fetch(API + "/api/public/reco/feedback", { method: "POST", headers: { "Content-Type": "text/plain" }, body: body, keepalive: true });
    } catch (e) {}
  }
  function _flush() { if (_consent) { while (_queue.length) { var e = _queue.shift(); _send(e[0], e[1]); } } else { _queue.length = 0; } }

  function track(type, item) {
    if (C.consentRequired === false || _consent === true) { _send(type, item); return; }
    if (_consent === false) return;
    _queue.push([type, item]); // decide once consent is known
  }

  function _artmieFallback() {
    try {
      if (typeof window.__artmieConsent === "function") return !!window.__artmieConsent("analytics");
      if (window.__artmieConsent && typeof window.__artmieConsent === "object") return !!window.__artmieConsent.analytics;
      if (document.cookie.indexOf("artmie_consent=analytics") !== -1 || document.cookie.indexOf("artmie_consent=all") !== -1) return true;
    } catch (e) {}
    return false;
  }
  function initConsent() {
    if (C.consentRequired === false) { _consent = true; return; }
    try {
      var sp = window.Shopify && window.Shopify.customerPrivacy;
      if (sp && typeof sp.analyticsProcessingAllowed === "function") { _consent = !!sp.analyticsProcessingAllowed(); _flush(); return; }
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
          var s = window.Shopify && window.Shopify.customerPrivacy;
          _consent = !!(s && s.analyticsProcessingAllowed && s.analyticsProcessingAllowed()) || (!s && _artmieFallback());
          _flush();
          try { if (s && s.subscribe) s.subscribe("visitorConsentCollected", function (ev) { _consent = !!(ev && ev.analyticsAllowed); _flush(); }); } catch (e) {}
        });
        return;
      }
    } catch (e) {}
    _consent = _artmieFallback(); _flush();
  }
  initConsent();

  function money(card) {
    if (!card.price) return "";
    var p = parseFloat(card.price);
    if (isNaN(p)) return "";
    return (Math.round(p * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (card.currency ? " " + card.currency : "");
  }

  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === "style") e.style.cssText = attrs[k]; else e.setAttribute(k, attrs[k]); }
    (children || []).forEach(function (c) { e.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
    return e;
  }

  function render(cards) {
    if (!cards || !cards.length) return;
    var mount = (C.mount && document.querySelector(C.mount)) || document.querySelector("main") || document.body;

    var wrap = el("section", { "class": "amh-reco", "data-amh-reco": "1",
      style: "margin:32px 0;padding:0 4px;font-family:Poppins,system-ui,Arial,sans-serif;" });

    wrap.appendChild(el("h2", { style: "font-size:20px;font-weight:700;margin:0 0 14px;color:#1a1a1a;border-left:4px solid " + accent + ";padding-left:10px;line-height:1.2;" }, [title]));

    var rail = el("div", { "class": "amh-reco-rail",
      style: "display:flex;gap:14px;overflow-x:auto;scroll-snap-type:x mandatory;padding-bottom:6px;-webkit-overflow-scrolling:touch;" });

    cards.forEach(function (card) {
      var a = el("a", { href: card.url, "data-handle": card.handle,
        style: "flex:0 0 168px;scroll-snap-align:start;text-decoration:none;color:inherit;display:block;border:1px solid #eee;border-radius:12px;overflow:hidden;background:#fff;transition:box-shadow .15s;" });
      a.onmouseenter = function () { a.style.boxShadow = "0 6px 20px rgba(0,0,0,.08)"; };
      a.onmouseleave = function () { a.style.boxShadow = "none"; };
      a.addEventListener("click", function () { track("click", card.handle); });

      var imgWrap = el("div", { style: "position:relative;width:100%;aspect-ratio:1/1;background:#f6f6f6;" });
      if (card.img) imgWrap.appendChild(el("img", { src: card.img, alt: card.title, loading: "lazy",
        style: "width:100%;height:100%;object-fit:cover;display:block;" }));
      if (card.onSale && card.discountPct > 0) imgWrap.appendChild(el("span", {
        style: "position:absolute;top:8px;left:8px;background:#e8542f;color:#fff;font-size:11px;font-weight:700;padding:2px 7px;border-radius:6px;" }, ["-" + card.discountPct + "%"]));
      a.appendChild(imgWrap);

      var body = el("div", { style: "padding:10px 10px 12px;" });
      body.appendChild(el("div", { style: "font-size:13px;line-height:1.3;color:#222;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:34px;" }, [card.title]));
      var m = money(card);
      if (m) body.appendChild(el("div", { style: "margin-top:6px;font-size:14px;font-weight:700;color:" + accent + ";" }, [m]));
      a.appendChild(body);
      rail.appendChild(a);
    });

    wrap.appendChild(rail);

    // Avoid duplicate insertions on re-run.
    var existing = document.querySelector("section.amh-reco[data-amh-reco]");
    if (existing) existing.parentNode.removeChild(existing);
    mount.appendChild(wrap);

    track("impression", null);
  }

  function load() {
    fetch(API + "/api/public/reco/recommend", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ market: market, placement: C.placement, count: count, session: sid })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res && res.cards) render(res.cards); })
      .catch(function () {});
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", load);
  else load();
})();
